enum ContactSupportModalSteps {
  chooseReason = 'chooseReason',
  otherRefundIssues = 'otherRefundIssues',
  cantAccessDepositMethodIssue = 'cantAccessDepositMethodIssue'
}

export {ContactSupportModalSteps}
